export const EXPERIMENT_NAMES = {
  reportSignup: "report_signup",
};
